import { Icon } from "@chakra-ui/react";

export default function Facebook({ ...props }) {
  return (
    <Icon width="32" height="32" viewBox="0 0 32 32" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 0c8.836 0 16 7.163 16 16 0 8.836-7.164 16-16 16S0 24.836 0 16C0 7.163 7.164 0 16 0zm3.985 9h-2.071c-2.488 0-3.363 1.254-3.363 3.363v1.552H13V16.5h1.55V24h3.105v-7.5h2.07L20 13.914h-2.345l.003-1.295c0-.673.065-1.035 1.033-1.035h1.294V9z"
      />
    </Icon>
  );
}
